import * as React from 'react'
import {cn} from '@frontrow/console/src/lib/utils'

type VariantT = 'label-1' | 'label-2'

type Props = {
  children?: React.ReactNode
  addClass?: string
  variant?: VariantT
  htmlFor?: string
}

export function Label({
  children,
  variant = 'label-1',
  addClass,
  htmlFor
}: Props): React.ReactElement {
  const variantClass = variant === 'label-1' ? 'block' : 'inline-block'
  return (
    <label
      htmlFor={htmlFor}
      className={cn('text-sm font-medium leading-none', variantClass, addClass)}
    >
      {children}
    </label>
  )
}
